import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType,
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { modReport_template } from "../components/templates/modReport_template";
import { header } from "./header";
import { downloadCSV } from "../../vendor/valnet/valnet_jslib/vnHelpers/helper_functions";
import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";

declare var ko: any;
declare var page: any;

export class mod_report extends vnModule_knockoutJS{

    protected modReportTemplate: modReport_template;
    protected currentFilters: any = {};

    protected getModuleName(){
        return "mod_report";
    }

    buildContent() : Array<Element>{

        this.modReportTemplate = new modReport_template("modReport", this.viewModel, this);

        const zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        const loadedModule = zoneHeader.loadedModule;
        if (loadedModule) {
            (<header>loadedModule).setHeaderTitle("Mod Report");
        }

        return [this.modReportTemplate.build()];
    }

    public fillPage() : void{
        // ensure the date picker calendars are initialized after the template is in the DOM
        this.modReportTemplate.initializeFilterOptions();
        this.modReportTemplate.buildDatePickerCalendar();
    }

    protected filterDateOnChange(): void {
    }

    protected filterSimpleOnChange(): void {
    }

    protected filterMultipleSelectorOnChange(): void {
        this.filterSimpleOnChange();
    }

    public getUsersSuggestion(keyword, idElement) {

        const subViewModel = {keyword: keyword, idElement: idElement};
        const usrReq_url: string = "/api/mod/authors/";
        const usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls["getModAuthors"] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls["getModAuthors"].onReadyStateFunction = this.onGetModAuthorsReturn;
        this.XHRHdls["getModAuthors"].execute();
    }

    protected onGetModAuthorsReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {
                const response = JSON.parse(req.request.response || "{}");
                let authors = [];
                if (response.data) {
                    if (response.data.authors) {
                        authors = response.data.authors;
                    } else if (response.data.users) {
                        authors = response.data.users;
                    } else {
                        authors = response.data;
                    }
                } else {
                    authors = response;
                }
                obj.modReportTemplate.setAuthorSuggestions(authors);
            });
        }
    }

    public getTagsSuggestion(keyword, idElement) {

        const subViewModel = {keyword: keyword, idElement: idElement};
        const usrReq_url: string = "/api/mod/games/";
        const usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls["getModGames"] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls["getModGames"].onReadyStateFunction = this.onGetModGamesReturn;
        this.XHRHdls["getModGames"].execute();
    }

    protected onGetModGamesReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {
                const response = JSON.parse(req.request.response || "{}");
                let games = [];
                if (response.data) {
                    if (response.data.games) {
                        games = response.data.games;
                    } else if (response.data.tags) {
                        games = response.data.tags;
                    } else {
                        games = response.data;
                    }
                } else {
                    games = response;
                }
                obj.modReportTemplate.setGameSuggestions(games);
            });
        }
    }

    public onClickExport(): void {
        this.modReportTemplate.setExportInProgress(true);

        const filters = this.modReportTemplate.getFiltersForRequest();
        const usrReq_url: string = "/api/mod/report/export/";
        const usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(filters)]);

        this.XHRHdls["modReportExport"] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdls["modReportExport"].mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdls["modReportExport"].onReadyStateFunction = this.onExportReportReturn;
        this.XHRHdls["modReportExport"].execute();
    }

    protected onExportReportReturn(req, obj) {

        return function () {
            if (req.request.readyState == 4) {
                obj.modReportTemplate.setExportInProgress(false);
                const responseParsed = JSON.parse(req.request.response || "{}");
                if (req.request.status == 200) {
                    const exportData = Array.isArray(responseParsed.data) ? responseParsed.data : [];
                    if (exportData.length > 0) {
                        downloadCSV({filename: obj.buildExportFilename(), data: exportData});
                    } else {
                        obj.getVnAppZone().notification = new vn_app_zone_notification(
                            vn_app_zone_notification.TYPE_WARNING,
                            "No data matched the selected filters."
                        );
                        obj.getVnAppZone().showNotificationToModule();
                    }
                } else {
                    obj.onUpdateError(req.request.status, responseParsed);
                }
            }
        };
    }

    protected buildExportFilename(): string {
        const now = new Date();
        const pad = (value: number) => value.toString();
        const parts = [
            now.getFullYear(),
            pad(now.getMonth() + 1),
            pad(now.getDate()),
            pad(now.getHours()),
            pad(now.getMinutes()),
            pad(now.getSeconds()),
        ];
        return `mod_report_${parts.join("_")}.csv`;
    }
}



// WEBPACK FOOTER //
// ./js/modules/mod_report.ts